import React, { Component } from "react";
import { 
  Button, 
  Form, 
  Popup 
} from "semantic-ui-react";
import DropzoneCommon from "../../components/content/DropzoneCommon"

class EcomImageForm extends Component {
  state = {};
  render() {
    const {
      imgURL,
      id,
      drop,
      copyURL,
      trash
    } = this.props;
    return (
      <Form>
        <DropzoneCommon
          onDrop={files => drop(id, files)}
          accept="image/*"
          acceptClassName="green"
          activeClassName="secondary"
          rejectClassName="red"
          className="ui dropzone"
        />
        
        {copyURL && (
          <Form.Group inline>
            <Form.Input
              value={imgURL}
              width={12}
              label={() => (
                <Popup
                  trigger={ <label style={{ width:"80px" }}>Asset URL</label> }
                  content="Click the save icon to copy URL to clipboard and paste as needed. This automatically populates after upload."
                  inverted
                />
              )}  
            />
            <Button
              icon="save alternate"
              onClick={e => copyURL(id)}
            />
          </Form.Group>
        )}
        
        {trash && (
            <Button.Group widths="2">
              <Button
                fluid
                color="red"
                icon="trash"
                content="Delete"
                onClick={e => { trash(id); }}
              />
            </Button.Group>
        )}
      </Form>
    );
  }
}

export default EcomImageForm;
